<template>
  <i-form ref="form"
          inline
          @submit.prevent="submit"
          :model="form"
          :rules="rules">
      <Row>
        <Col span="6">
          <FormItem :label="$t('pages_products_components_sku_edit_form_769')"
            prop="name">
            <i-input v-model="form.name"
                    readonly
                    @on-focus="onEditSkuProp(form.mall_properties)"
                    :placeholder="$t('pages_products_components_sku_edit_form_770')" />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('pages_products_components_sku_edit_form_771')"
                    prop="sales">
            <i-input :placeholder="$t('pages_products_components_sku_edit_form_772')"
                    v-model="form.sales" />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('pages_product_stocks_index_740')"
                    prop="stocks">
            <i-input :placeholder="$t('pages_products_components_sku_edit_form_773')"
                    v-model="form.stocks" />
          </FormItem>
        </Col>
    </Row>
    <Row>
      <Col span="6">
        <FormItem :label="$t('pages_products_components_sku_edit_form_774')"
        prop="jinghuojia">
          <i-input type="number"
                  :placeholder="$t('pages_products_components_sku_edit_form_775')"
                  v-model="form.jinghuojia" />
        </FormItem>
      </Col>
      <Col span="6">
        <FormItem :label="$t('pages_ai_thirdparty_166')"
                  prop="lingshoujia">
          <i-input type="number"
                  :placeholder="$t('pages_products_components_sku_edit_form_776')"
                  v-model="form.lingshoujia" />
        </FormItem>
      </Col>
      <Col span="6">
        <FormItem :label="$t('pages_ai_thirdparty_167')"
                  prop="huiyuanjia">
          <i-input type="number"
                  :placeholder="$t('pages_products_components_sku_edit_form_777')"
                  v-model="form.huiyuanjia" />
        </FormItem>
      </Col>
    </Row>
    <Row v-if="wechatDisplay">
      <Col span="6">
        <FormItem
          :label="$t('pages_products_components_sku_edit_form_778')"
          prop="wechat_lingshoujia">
          <i-input type="number"
                   :placeholder="$t('pages_products_components_sku_edit_form_779')"
                   v-model="form.wechat_lingshoujia" />
        </FormItem>
      </Col>
      <Col span="6">
        <FormItem
          :label="$t('pages_products_components_sku_edit_form_780')"
          prop="wechat_huiyuanjia">
          <i-input type="number"
                   :placeholder="$t('pages_products_components_sku_edit_form_781')"
                   v-model="form.wechat_huiyuanjia" />
        </FormItem>
      </Col>
      <Col span="6">
        <FormItem
          :label="$t('pages_products_components_sku_edit_form_782')"
          prop="rebate_price">
          <i-input type="number"
                   :placeholder="$t('pages_products_components_sku_edit_form_783')"
                   v-model="form.rebate_price" />
        </FormItem>
      </Col>
    </Row>
    <Form-item :label="$t('pages_products_components_sku_edit_form_784')"
               prop="fresh_product_customer_levels_attributes">
      <CustomerLevels v-model="form.fresh_product_customer_levels_attributes" />
    </Form-item>
    <FormItem :label="$t('libs_table_render_86')"
              prop="images">
      <uploader @uploadedUrl="onUploadImage"
                :url="form.image"></uploader>
    </FormItem>
    <!-- <FormItem label="库存预警数量"
              prop="stocks_warning">
      <i-input placeholder="库存预警数量"
               v-model="form.stocks_warning" />
    </FormItem> -->
    <slot name="footer"></slot>
  </i-form>
</template>

<script>
import i18n from '../../../locales/index'

import Uploader from "@/components/uploader-aliyun/single";
import CustomerLevels from '../customer_levels';
import { isEqual } from 'lodash';
export default {
  name: 'SkuEditForm',
  props: ['value', 'wechatDisplay'],
  components: {
    Uploader,
    CustomerLevels
  },
  data () {
    const vm = this
    return {
      form: {
        name: '',
        images: '',
        mall_product_id: 0,
        jinghuojia: 0,
        lingshoujia: 0,
        huiyuanjia: 0,
        sales: 0,
        stocks: 0,
        stocks_warning: 0,
        wechat_lingshoujia: '',
        wechat_huiyuanjia: '',
        rebate_price: ''
      },
      rules: {
        name: [{ required: true, message: i18n.t('pages_booking_store_products_index_216') }],
        huiyuanjia: [{ required: true, message: i18n.t('pages_products_components_sku_edit_form_785') }],
        lingshoujia: [{ required: true, message: i18n.t('pages_products_components_sku_edit_form_786') }],
        jinghuojia: [{ required: true, message: i18n.t('pages_products_components_sku_edit_form_787') }],
        wechat_lingshoujia: [{
          validator (rule, value, callback) {
            const required = !!value || value === 0 || value === '0'
            return vm.wechatDisplay ? required : true
          },
          required: true,
          message: i18n.t('pages_products_components_sku_edit_form_788')
        }],
        wechat_huiyuanjia: [{
          validator (rule, value, callback) {
            const required = !!value || value === 0 || value === '0'
            return vm.wechatDisplay ? required : true
          },
          required: true,
          message: i18n.t('pages_products_components_sku_edit_form_789')
        }],
      },
    };
  },
  methods: {
    onFormChange (value) {
      this.$nextTick(() => {
        this.$refs.form.validate(valid => {
          this.$emit('input', { ...value, _valid_: !!valid });
        });
      });
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      });
    },
    onUploadImage (url) {
      this.form.image = url;
    },
    onEditSkuProp (props) {
      this.$emit('onEditSkuProp', props)
    }
  },
  mounted () {
    this.onFormChange(this.value);
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        if (isEqual(val, this.form)) return;
        this.$set(this, 'form', { ...val });
      }
    },
    form: {
      deep: true,
      handler (value) {
        this.onFormChange(value);
      },
    },
    wechatDisplay: {
      deep: true,
      handler () {
        this.onFormChange(this.value);
      },
    }
  },
};
</script>

<style>
</style>
